var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _path10, _path11, _path12, _ellipse4, _ellipse5, _circle, _rect, _rect2, _ellipse6, _ellipse7, _path13, _circle2, _circle3, _path14, _ellipse8, _circle4, _rect3, _rect4, _ellipse9, _ellipse10, _circle5, _circle6, _path15, _ellipse11, _path16, _circle7, _rect5, _rect6, _ellipse12, _ellipse13, _path17, _ellipse14, _ellipse15, _circle8, _rect7, _rect8, _ellipse16, _ellipse17, _path18, _ellipse18, _ellipse19, _ellipse20, _circle9, _rect9, _rect10, _ellipse21, _ellipse22, _path19, _circle10, _circle11, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkflowEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 690.06055,
    height: 622.3536,
    viewBox: "0 0 690.06055 622.3536",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.57224,563.70393a4.75474,4.75474,0,0,1-6.35718-6.27512c-.07312-.48591-.12571-.83481-.19884-1.32072q-.11935-.11872-.23932-.237c-8.06365-7.94283-21.72414-2.156-21.69794,9.1626.02316,10.04585-.91852,20.51209,1.74983,30.029a37.77438,37.77438,0,0,0,5.62114,11.731A151.44464,151.44464,0,0,1,328.48537,554.07a146.17408,146.17408,0,0,1-5.4512-15.39549q-1.87428-6.4329-3.17513-13.00268a153.19909,153.19909,0,0,1,2.99513-71.6232,40.77066,40.77066,0,0,0,8.86168-22.7703,31.09989,31.09989,0,0,0-.66731-8.93191c-.71988.41819-1.468.80414-2.20872,1.17233-.23208.11158-.47655.22846-.70859.34014l-.08781.04141a4.71087,4.71087,0,0,1-6.52909-5.58948q.2396-.81321.48-1.62608c.23858-.8331.49482-1.65886.73334-2.49182a2.34448,2.34448,0,0,0,.084-.25521c.277-.9518.55906-1.891.83608-2.84278a13.62207,13.62207,0,0,0-5.785-2.261c-7.165-.96573-14.13048,4.68785-16.11248,11.63223-1.99447,6.94947.27158,14.58274,4.43848,20.48273,3.56355,5.05222,8.39465,9.032,13.45863,12.621-.14523.53009-.30812,1.05284-.45325,1.58288a154.18839,154.18839,0,0,0-5.01794,29.72964,64.09769,64.09769,0,0,0-15.01062-25.99425c-6.78672-6.7405-15.99073-10.95964-24.51449-15.67656-10.2384-5.66572-22.43421,3.771-19.12976,14.99613q.048.163.09676.32561,1.53587.18177,3.05519.47154a6.44948,6.44948,0,0,1,2.1264,11.83187l-.11351.06945a64.17223,64.17223,0,0,0,5.26036,8.20051,66.07238,66.07238,0,0,0,46.32118,25.52262c.59133.04619,1.17024.09757,1.75637.13133a157.38092,157.38092,0,0,0,7.55606,40.0508,149.26937,149.26937,0,0,0,9.39329,22.19615l-.14707-.24656a39.44354,39.44354,0,0,0-21.20583-15.82224c-12.843-3.85833-27.55918-1.1055-40.5118-3.108-6.235-.964-10.95624,5.622-7.68408,11.0162q.07833.12916.15738.258a43.32944,43.32944,0,0,1,5.38518.28676q1.53593.18192,3.05519.47154a6.44955,6.44955,0,0,1,2.12644,11.832l-.11365.06939c-.08214.049-.15186.09289-.2339.14189a64.22762,64.22762,0,0,0,18.03343,12.51319A66.131,66.131,0,0,0,342.2,585.343l.01252-.00523a157.33608,157.33608,0,0,0,21.649,24.39316l34.83637-14.55838c-.03681-.4393-.09148-.88584-.14082-1.3199a42.89759,42.89759,0,0,1-9.87941,3.45414c1.25926-4.25172,2.508-8.52835,3.7673-12.78a2.34586,2.34586,0,0,0,.08407-.25511c.6327-2.171,1.28311-4.3349,1.91581-6.50594l-.00013-.0023a62.83649,62.83649,0,0,0-7.871-14.05928Zm-72.6876-61.80369.008-.03241.00243.05736Zm21.35349,72.78525-.58143-.54891c-.191-.49221-.3945-.97919-.61573-1.47335-.05745-.13748-.13977-.26433-.19718-.4017.47236.81458.93234,1.63446,1.41723,2.44381Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M706.25,324.30278a62.83608,62.83608,0,0,0-1.84118,16.007l.00076.00217c1.42091,1.75919,2.85539,3.50492,4.2763,5.26411a2.34417,2.34417,0,0,0,.17593.203c2.80131,3.43726,5.60251,6.90168,8.40382,10.339a42.89815,42.89815,0,0,1-10.44733.62238c.12185.41952.24359.85261.379,1.27213h37.756a157.33574,157.33574,0,0,0,10.56907-30.85448h.01357a66.131,66.131,0,0,0,47.95979-21.04332,64.22737,64.22737,0,0,0,11.81393-18.49907c-.09459-.01358-.17582-.02715-.27052-.04073l-.13162-.0202a6.44954,6.44954,0,0,1-2.60029-11.73693q1.289-.85245,2.63711-1.61313a43.325,43.325,0,0,1,4.85817-2.34107q.0233-.14938.04572-.29876c.93916-6.23879-5.95643-10.495-11.33762-7.20141-11.17885,6.84206-25.81853,9.97655-36.1806,18.48864A39.44361,39.44361,0,0,0,758.865,305.62767l-.04061.2842a149.27013,149.27013,0,0,0,.10827-24.10168,157.38053,157.38053,0,0,0-8.47148-39.86721c.52779-.25717,1.04212-.5278,1.56991-.79842a66.07236,66.07236,0,0,0,32.89787-41.41,64.17245,64.17245,0,0,0,1.69154-9.59472l-.13151-.02031a6.44947,6.44947,0,0,1-2.60029-11.73683q1.289-.85244,2.6371-1.61312-.01774-.16893-.03627-.33775c-1.2794-11.63127-16.17081-15.63564-23.43283-6.46022-6.04581,7.63885-12.91121,15.0807-16.574,23.91685a64.09761,64.09761,0,0,0-3.8267,29.77207,154.1888,154.1888,0,0,0-16.09338-25.49577c-.33829-.43309-.69015-.85261-1.02854-1.2857,3.28848-5.26412,6.21142-10.799,7.55131-16.83457,1.56969-7.05046.71719-14.96722-3.8027-20.61024-4.50642-5.64312-13.11321-8.17369-19.35178-4.51988a13.622,13.622,0,0,0-4.46581,4.3168c.6226.77138,1.245,1.52919,1.86758,2.30056a2.34351,2.34351,0,0,0,.17593.20308c.54125.67658,1.09609,1.33968,1.63745,2.01636q.53545.65713,1.06992,1.31524a4.71087,4.71087,0,0,1-3.86895,7.6748l-.097-.00435c-.25716-.01357-.52779-.02715-.78495-.04061-.82546-.05409-1.66449-.12174-2.49-.23a31.09981,31.09981,0,0,0,2.82836,8.49852,40.77074,40.77074,0,0,0,16.95642,17.59249,153.199,153.199,0,0,1,30.38076,64.92967q1.33985,6.55666,2.08413,13.22149a146.1742,146.1742,0,0,1,.90669,16.30689,151.44452,151.44452,0,0,1-13.77632,62.89974,37.77432,37.77432,0,0,0,.66311-12.99126c-1.20762-9.80985-6.11217-19.10364-9.96439-28.38157-4.34016-10.45341-19.17564-10.52541-23.553-.08753q-.06516.1554-.12945.31092c.1199.47653.20591.81873.3258,1.29526a4.75475,4.75475,0,0,1-3.44595,8.24114Zm43.23693-85.0258-.01987-.05386.01987.02682Zm8.34963,75.39057c.13532-.93373.24359-1.86757.36533-2.8013,0,.14888-.027.29766-.027.44666-.01358.54126-.01358,1.06905,0,1.59684l-.32482.73066Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M668.21165,556.96021h-115.51a6.1631,6.1631,0,0,0-6.15377,6.16965V745.60165H674.3813V563.12986A6.16641,6.16641,0,0,0,668.21165,556.96021ZM610.84527,660.63845a13.70383,13.70383,0,0,1-13.63985-13.63975V625.95216a13.6398,13.6398,0,0,1,27.2796,0V646.9987a13.70365,13.70365,0,0,1-13.63975,13.63975Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.15137,739.76511V757.37a3.44873,3.44873,0,0,0,3.44174,3.44164h121.743A3.459,3.459,0,0,0,674.7778,757.37v-17.6049Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M859.48585,272.19237H365.7256a16.02852,16.02852,0,0,0-16.003,16.0029V621.38678a16.01831,16.01831,0,0,0,16.003,16.0029H859.48585a16.0183,16.0183,0,0,0,16.003-16.0029V288.19527A16.02851,16.02851,0,0,0,859.48585,272.19237Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M855.36253,283.74652h-485.51a8.58039,8.58039,0,0,0-8.56,8.58v324.93a8.56973,8.56973,0,0,0,8.56,8.56h485.51a8.56969,8.56969,0,0,0,8.56-8.56v-324.93A8.58035,8.58035,0,0,0,855.36253,283.74652Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M423.10488,607.1895a53.04951,53.04951,0,0,1-3.34507,18.62906H369.85089a8.57312,8.57312,0,0,1-8.55835-8.55836V554.48709a52.71641,52.71641,0,0,1,8.43379-.67614A53.37521,53.37521,0,0,1,423.10488,607.1895Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#673ab7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M863.92253,292.32653v282.82a179.02233,179.02233,0,0,1-183.37-291.4h174.81A8.58035,8.58035,0,0,1,863.92253,292.32653Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M830.95843,328.51954h-454.293a1.807,1.807,0,0,1,0-3.61318h454.293a1.807,1.807,0,0,1,0,3.61318Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.62,
    cy: 166.0356,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.19502,
    cy: 166.0356,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.77004,
    cy: 166.0356,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M808.93717,296.71805h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M808.93717,304.10242h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M808.93717,311.47709h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 547.48819,
    cy: 194.37414,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-117.7187 466.92679) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 641.80352,
    cy: 221.83566,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-247.67004 324.93747) rotate(-39.93837)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341.02666,
    cy: 75.53456,
    r: 43.06732,
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 346.17172,
    y: 109.33409,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 320.00424,
    y: 109.33409,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.35232,
    cy: 133.04838,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.18484,
    cy: 132.50324,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M582.47354,160.22082c3.84558-15.487,20.82055-24.60077,37.91473-20.35617S648.22256,160.105,644.377,175.592s-16.604,15.537-33.69812,11.29236S578.628,175.70785,582.47354,160.22082Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.58804,
    cy: 66.44697,
    r: 14.35864,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.68667,
    cy: 72.30018,
    r: 4.78621,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M607.80253,231.26654c.94684,5.20123-11.7394,14.10428-16.94063,15.05112a9.57245,9.57245,0,0,1-11.13208-7.70325h0l-.00336-.01849c-.94177-5.20215,3.08039-7.043,8.28254-7.98475S606.86082,226.06445,607.80253,231.26654Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#fff"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 754.99875,
    cy: 528.83556,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-379.36804 666.32917) rotate(-52.45248)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.83622,
    cy: 382.5345,
    r: 43.06735,
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 551.37808,
    y: 416.3341,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 525.21061,
    y: 416.3341,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.55868,
    cy: 440.04838,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.3912,
    cy: 439.50323,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 543.74588,
    cy: 371.63128,
    r: 14.71921,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.74588,
    cy: 378.63128,
    r: 4.90643,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M841.58267,481.30618c3.47748-15.57379-7.63867-31.31042-24.82861-35.1488s-33.94421,5.67511-37.42169,21.24884,7.91492,21.31762,25.10486,25.156S838.1052,496.88,841.58267,481.30618Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#673ab7"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.3141,
    cy: 539.37419,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-406.00651 282.34078) rotate(-25.87116)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M820.96045,536.89456c0,4.21515-10.85327,12.53857-22.89657,12.53857s-23.33515-11.867-23.33515-16.08209,11.29193.81775,23.33515.81775S820.96045,532.67941,820.96045,536.89456Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.54865,
    cy: 527.5344,
    r: 43.06733,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 492.92302,
    y: 561.33409,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 519.09052,
    y: 561.33409,
    width: 13.08373,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.79583,
    cy: 726.87158,
    rx: 4.08868,
    ry: 10.90314,
    transform: "translate(-478.02346 962.92297) rotate(-64.7233)",
    fill: "#2f2e41"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 783.96337,
    cy: 726.32641,
    rx: 4.08868,
    ry: 10.90314,
    transform: "translate(-438.59544 1041.28729) rotate(-67.94033)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M725.74162,626.3063c-3.47748-15.57379,7.63865-31.31042,24.82866-35.1488s33.94421,5.67511,37.42169,21.2489-7.91492,21.31769-25.10486,25.156S729.21911,641.88009,725.74162,626.3063Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#673ab7"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 811.62203,
    cy: 646.23643,
    rx: 23.89244,
    ry: 7.50055,
    transform: "translate(-318.76494 1064.18652) rotate(-70.98453)",
    fill: "#2f2e41"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 715.91667,
    cy: 645.23643,
    rx: 7.50055,
    ry: 23.89244,
    transform: "translate(-501.55284 556.02053) rotate(-44.9779)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.62621,
    cy: 560.75094,
    r: 43.06733,
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 167.00059,
    y: 594.55062,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 193.16808,
    y: 594.55062,
    width: 13.08373,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.90367,
    cy: 618.26492,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.07121,
    cy: 617.71975,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M399.81918,659.52284c-3.47747-15.57379,7.63866-31.31043,24.82866-35.1488s33.94422,5.6751,37.4217,21.2489-7.91492,21.31768-25.10486,25.156S403.29668,675.09663,399.81918,659.52284Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#3f3d56"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.69959,
    cy: 699.45296,
    rx: 7.50055,
    ry: 23.89244,
    transform: "translate(-619.98117 654.06156) rotate(-62.12179)",
    fill: "#2f2e41"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.72383,
    cy: 477.01587,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-417.63921 92.63034) rotate(-25.37426)",
    fill: "#2f2e41"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.4085,
    cy: 504.47739,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-520.60773 301.26804) rotate(-50.06163)",
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.24591,
    cy: 358.17629,
    r: 43.06732,
    fill: "#2f2e41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111.01711,
    y: 391.97582,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.18459,
    y: 391.97582,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.92025,
    cy: 415.69011,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.08773,
    cy: 415.14498,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M397.73848,442.86256c-3.84558-15.487-20.82055-24.60077-37.91473-20.35617s-27.83429,20.24029-23.98871,35.72729,16.60394,15.537,33.69812,11.29236S401.58407,458.34959,397.73848,442.86256Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#673ab7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.68453,
    cy: 349.0887,
    r: 14.35864,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5859,
    cy: 354.94191,
    r: 4.78621,
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M381.64687,517.82731a9.57244,9.57244,0,1,0,18.83533,3.42883h0l.00335-.01849c.94178-5.20215-3.08038-7.043-8.28253-7.98474S382.58858,512.62522,381.64687,517.82731Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M943.83959,760.805l-666.75.30733a1.19069,1.19069,0,1,1,0-2.38137l666.75-.30733a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-254.96973 -138.8232)",
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowEmpty);
export default __webpack_public_path__ + "static/media/workflow_empty.55ef149bd518376e1fe142b66c80ccd1.svg";
export { ForwardRef as ReactComponent };